import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./bscDmcMining.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.dmcMiningContractAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getBscDmcMiningAddress = () => {
    return contractAddress;
}

const getDmcMiningContract = () => {
    // console.log(contractConst.contract)
    return contractConst.contract;
}

const getDmcTotalReward = async([blockNum], options) => {
    return $web3js.call(getDmcMiningContract().methods.getTotalReward, [blockNum], options, $web3js.fromWei);
}

const getDmcPerBlock = async(options) => {
    return $web3js.call(getDmcMiningContract().methods.dmcPerBlock, [], options, $web3js.fromWei);
}

const getBscTotalAllocPoint = async(options) => {
    return $web3js.call(getDmcMiningContract().methods.totalAllocPoint, [], options);
}

const getBscCurrentBlockReward = async(options) => {
    return $web3js.call(getDmcMiningContract().methods.getCurrentBlockReward, [], options, $web3js.fromWei);
}

const sumPoolAllocPoint = async([_pids], options) => {
    return $web3js.call(getDmcMiningContract().methods.sumPoolAllocPoint, [_pids], options, handleSumPoolAllocPoint);
}

const handleSumPoolAllocPoint = async(res) => {
    // console.log(res)
    let index = 0;
    let subAllocPoint = res[index++];
    let totalAllocPoint = res[index++];

    subAllocPoint = await $web3js.fromWei(subAllocPoint);
    totalAllocPoint = await $web3js.fromWei(totalAllocPoint);

    return {
        subAllocPoint,
        totalAllocPoint,
    }
}

const getBscDmcMiningPoolInfo = ([_pid], options) => {

    return $web3js.call(getDmcMiningContract().methods.getPoolInfo, [_pid], options, handlePoolInfo);
}

const handlePoolInfo = async(res) => {
    let index = 0;
    let allocPoint = res[index++];
    let totalToken = res[index++];
    let totalReward = res[index++];
    let lpToken = res[index++];

    totalToken = await $erc20.fromErc20Value(totalToken, lpToken);
    totalReward = await $web3js.fromWei(totalReward);

    return {
        allocPoint,
        totalToken,
        totalReward,
        lpToken,
    }
}

const getBscDmcMiningUserInfo = ([_pid, _user], options) => {
    return $web3js.call(getDmcMiningContract().methods.getUserInfo, [_pid, _user], options, handleUserInfo);
}

const handleUserInfo = async(res) => {

    let index = 0;
    let amount = res[index++];
    let reward = res[index++];
    let lpToken = res[index++];
    let dlpIncome = res[index++];
    amount = await $erc20.fromErc20Value(amount, lpToken);
    reward = Vue.prototype.$numberUtils.movePointLeft(reward, 18);
    dlpIncome = await $erc20.fromErc20Value(dlpIncome, lpToken);

    return {
        amount,
        reward,
        lpToken,
        dlpIncome
    }
}

const bscDmcMiningDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getDmcMiningContract().methods.deposit, [_pid, _amount], options, callback);
}

const bscDmcMiningDepositEstimateSend = async([_pid, _amount, _contractAddress, ], options) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise;
    gasPromise = $web3js.estimateSend(getDmcMiningContract().methods.deposit, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const bscDmcMiningWithdraw = async([_pid, _amount, _contractAddress], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    return $web3js.send(getDmcMiningContract().methods.withdraw, [_pid, _amount], options, callback);
}

const bscDmcMiningWithdrawEstimateSend = async([_pid, _amount, _contractAddress], options) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise;
    gasPromise = $web3js.estimateSend(getDmcMiningContract().methods.withdraw, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const dmcMiningWithdrawAll = async([_pid, _aggregator, _joinPid], options, callback) => {
    if (!!_aggregator && !!_joinPid) {
        _joinPid = $web3js.stringToBytes32(_joinPid);
        return $web3js.send(getDmcMiningContract().methods.withdrawAll, [_aggregator, _pid, _joinPid], options, callback);
    }
    return $web3js.send(getDmcMiningContract().methods.withdrawAll, [_pid], options, callback);
}

const dmcMiningWithdrawAllEstimateSend = async([_pid, _aggregator, _joinPid], options) => {
    let gasPromise;
    if (!!_aggregator && !!_joinPid) {
        _joinPid = $web3js.stringToBytes32(_joinPid);
        gasPromise = $web3js.estimateSend(getDmcMiningContract().methods.withdrawAll, [_aggregator, _pid, _joinPid], options);
    } else {
        gasPromise = $web3js.estimateSend(getDmcMiningContract().methods.withdrawAll, [_pid], options);
    }
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

export default {
    getBscDmcMiningUserInfo,
    bscDmcMiningDeposit,
    bscDmcMiningDepositEstimateSend,
    getBscDmcMiningAddress,
    getBscDmcMiningPoolInfo,
    getBscCurrentBlockReward,
    getBscTotalAllocPoint,
    bscDmcMiningWithdraw,
    bscDmcMiningWithdrawEstimateSend

}


// WEBPACK FOOTER //
// ./src/lib/contract/bscDmcMining/index.js